import { canViewTxs } from '@/general/src/auth/can.js'
import { TxsForAdmin } from '@/general/src/subscription/webapp/components/TxsForAdmin/index.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { Block, Segment } from '@/webapp/src/lib/uninty.components.js'

export const AdminTxListPage = withPageWrapper({
  title: 'Транзакции',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  checkAccess: ({ ctx }) => canViewTxs(ctx.me.admin),
})(() => {
  return (
    <Block fcnw>
      <Segment title="Транзакции" size="m">
        <TxsForAdmin />
      </Segment>
    </Block>
  )
})
